import React from 'react';
import { Button, Grid, Icon } from 'semantic';
import ThemedSegment from 'components/semantic/Segment';
import { TFunction, useTranslation } from 'react-i18next';
import {
  TariffComponent as TariffComponentType,
  DynamicPrice,
  BasePrice,
  TimePrice,
} from 'screens/GroupsAndPolicies/types';

type Props = {
  values: TariffComponentType;
  onEdit?: () => void;
  onRemove?: () => void;
};

export const TariffComponentPreview: React.FC<Props> = ({
  values,
  onEdit,
  onRemove,
}) => {
  const { t } = useTranslation();

  return (
    <ThemedSegment offbackground>
      {/* TODO: there must be a better way to align this with Semantic? */}
      <Grid columns="equal" verticalAlign="middle">
        <Grid.Row>
          {/* TODO: make draggable */}
          <Grid.Column style={{ width: '1rem', flexGrow: 0 }}>
            <Icon name="resize vertical" />
          </Grid.Column>
          <Grid.Column width={8}>
            {/* TODO: fix currency */}
            <p>{formatPrice(values?.price, 'EUR', t)}</p>
            {/* TODO: Display restrictions preview */}
          </Grid.Column>
          <Grid.Column floated="right" width={2}>
            {onEdit && (
              <Button icon="edit" basic size="mini" onClick={onEdit} />
            )}
            {onRemove && (
              <Button
                icon="trash"
                basic
                size="mini"
                onClick={onRemove} // TODO: add prompt?
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </ThemedSegment>
  );
};

// TODO: add restrictions preview formatting
function formatPrice(
  price: TariffComponentType['price'],
  currency: string,
  t: TFunction<'translation', undefined>
) {
  if (!price) return '';

  // TODO: get currency symbol properly
  const currencySymbol = '€';

  switch (price?.type) {
    case 'DYNAMIC':
      return t(
        'tariff.component.previewDynamicPrice',
        'Dynamic price, Surcharge: {{currencySymbol}}{{surcharge}}/kWh, Backup: {{currencySymbol}}{{default}}/kWh',
        {
          currencySymbol,
          surcharge: (price as DynamicPrice).surcharge,
          default: (price as DynamicPrice).backup,
        }
      );
    case 'ENERGY':
      return t(
        'tariff.component.previewEnergyPrice',
        'Energy price: {{currencySymbol}}{{price}}/kWh',
        {
          currencySymbol,
          price: (price as BasePrice).value,
        }
      );
    case 'TIME':
      return t(
        'tariff.component.previewTimePrice',
        'Time price: {{currencySymbol}}{{price}}/{{format}}',
        {
          currencySymbol,
          price: (price as TimePrice).value,
          format: (price as TimePrice).format,
        }
      );
    case 'PARKING_TIME':
      return t(
        'tariff.component.previewParkingTimePrice',
        'Parking time price: {{currencySymbol}}{{price}}/{{format}}',
        {
          currencySymbol,
          price: (price as TimePrice).value,
          format: (price as TimePrice).format,
        }
      );
    case 'FLAT':
      return t(
        'tariff.component.previewFlatPrice',
        'Flat price: {{currencySymbol}}{{price}}/session',
        {
          currencySymbol,
          price: (price as BasePrice).value,
        }
      );
    default:
      return t('tariff.component.previewUnknownPrice', 'Unknown price type');
  }
}
